module.exports = __webpack_public_path__ + "img/background002.7767c1b3.jpg";